export default function formatRuntime(start, end) {
  const createdAt = new Date(start);
  const finishedAt = new Date(end);
  const diff = new Date(finishedAt.getTime() - createdAt.getTime());
  const hours = Math.floor(diff / 1000 / 60 / 60);
  const minutes = (`0${Math.floor((diff / 1000 / 60) % 60)}`).substr(-2);
  const seconds = (`0${Math.floor((diff / 1000) % 60)}`).substr(-2);
  return `${hours}:${minutes}:${seconds}`;
}
